<template>
    <div class="home">
        <banner isHome="true"></banner>
        <div class="site-content animate">
            <!--通知栏-->
            <div class="notify">
                <div class="search-result" v-if="hideSlogan">
                    <span v-if="searchWords">搜索结果："{{searchWords}}" 相关文章</span>
                    <span v-else-if="category">分类 "{{category}}" 相关文章</span>
                </div>
                <quote v-else>{{notice}}</quote>
            </div>

            <!--文章列表-->
            <main class="site-main" :class="{'search':hideSlogan}">
                <section-title v-if="!hideSlogan">推荐</section-title>
                <post v-for="(item, index) in articleList " :post="item" :key="index"></post>
            </main>

            <!--加载更多-->
            <div class="more" v-show="hasNextPage">
                <div class="more-btn" @click="onMore()">加载更多</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from '@/components/banner'
    import Feature from '@/components/feature'
    import sectionTitle from '@/components/section-title'
    import Post from '@/components/post'
    import SmallIco from '@/components/small-ico'
    import Quote from '@/components/quote'
    import {queryArticleList} from '@/api'

    export default {
      name: 'Home',
      props: ['cate', 'words'],
      data() {
          return {
              articleList: [],
              currPage: 1,
              pageSize: 10,
              isOnMore: false,
              isUpdLoading: false,
              hasNextPage: true
          }
      },
      components: {
          Banner,
          Feature,
          sectionTitle,
          Post,
          SmallIco,
          Quote
      },
      computed: {
          searchWords() {
            return this.$route.params.words
          },
          category() {
            return this.$route.params.cate
          },
          hideSlogan() {
            return this.category || this.searchWords
          },
          notice() {
            return this.$store.getters.notice
          }
      },
      methods: {
        async onMore(){
          this.isOnMore = true;
          await this.getList();
          this.isOnMore = false;
        },
        async getList() {
          const type = this.$route.params.type;
          let res = null;
          //请求页面数据
          if(type === "fenglei" && this.hasNextPage){
            const id = this.$route.params.id
            res = await queryArticleList(this.currPage, this.pageSize, 1, id);
          }
          if(type === "sousuo" && this.hasNextPage){
            const words = this.$route.params.words
            res = await queryArticleList(this.currPage, this.pageSize, 0, words);
          }
          if(res != null && res.data != null && res.data.length !== 0){
            ++this.currPage;
            const list = res.data;
            for(let i=0;i<list.length;i++){
              this.articleList.push(list[i])
            }
            if(res.data.length !== this.pageSize){
              this.hasNextPage = false;
            }
          }else {
            this.hasNextPage = false;
          }
        },
        async updateList(){
          if(this.isOnMore){
            return;
          }
          this.isUpdLoading = true;
          this.currPage = 1;
          this.hasNextPage = true;
          this.articleList = [];
          await this.getList();
          this.isUpdLoading = false;
        }
      },
      beforeUpdate() {
        if(!this.isUpdLoading){
          this.updateList();
        }
      },
      mounted() {
        this.getList();
      }
    }
</script>
<style scoped lang="less">

    .site-content {
        .notify {
            margin: 60px 0;
            border-radius: 3px;
            & > div {
                padding: 20px;
            }
        }
        .search-result {
            padding: 15px 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            border: 1px dashed #ddd;
            color: #828282;
        }
    }

    .top-feature {
        width: 100%;
        height: auto;
        margin-top: 30px;

        .feature-content {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            position: relative;

            .feature-item {
                width: 32.9%;
            }
        }
    }

    .site-main {
        padding-top: 80px;

        &.search {
            padding-top: 0;
        }
    }

    .more{
        margin: 50px 0;
        .more-btn{
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #ADADAD;
            border: 1px solid #ADADAD;
            border-radius: 20px;
            margin: 0 auto;
            cursor: pointer;
            &:hover{
                color: #8fd0cc;
                border: 1px dashed #8fd0cc;
            }
        }
    }

    /******/
    @media (max-width: 800px) {
        .top-feature {
            display: none;
        }

        .site-main {
            padding-top: 40px;
        }

        .site-content {
            .notify {
                margin: 30px 0 0 0;
            }

            .search-result {
                margin-bottom: 20px;
                font-size: 16px;
            }
        }
    }

    /******/
</style>
